export default {
  banner: {
    title: "Authing 合作网络",
    subtitle:
      "我们找到一种方法，可以帮助企业管理员和开发者更简单、高效地完成应用单点登录。",
    intro: "进一步了解",
    get: "查看",
    card1: {
      name: "飞书",
      descript:
        "飞书是真正的一站式企业沟通与协作平台，整合即时沟通、日历、视频会议、电话会议、云文档、云盘、工作台、考勤打卡等功能于一体，打造高效的办公方式，加速企业成长。",
    },
    card2: {
      name: "AWS 中国",
      descript:
        "亚马逊云科技，为全球客户提供整套基础设施和云解决方案。以弹性云服务器、云存储、数据库、机器学习为主的安全、可靠的云计算服务，帮助企业轻松上云。",
    },
    card3: {
      name: "阿里云",
      descript:
        "阿里云提供免费试用、云服务器、云数据库、云安全、云企业应用等云计算服务，以及大数据、人工智能服务、精准定制基于场景的行业解决方案。",
    },
    card4: {
      name: "华为云",
      descript:
        "华为云为用户提供云服务器、云数据库、云存储、CDN、大数据、云安全等公有云产品和电商、金融、游戏等多种解决方案。",
    },
  },

  recommend: {
    title: "推荐应用",
    get: "查看",
    item1: {
      name: "飞书",
      descript:
        "飞书是真正的一站式企业沟通与协作平台，整合即时沟通、日历、视频会议、电话会议、云文档、云盘、工作台、考勤打卡等功能于一体，打造高效的办公方式，加速企业成长。",
    },
    item2: {
      name: "GitLab",
      descript:
        "快速迭代，共同创新:我们的开放 DevOps 平台是一个具有无与伦比的协作、可见性和开发速度的单一应用程序。",
    },
    item3: {
      name: "Zabbix",
      descript:
        "Zabbix 是一个成熟、易用的企业级开源监控解决方案，适用于百万级指标的网络监控和应用监控。",
    },
    item4: {
      name: "华为云",
      descript:
        "Zabbix 是一个成熟、易用的企业级开源监控解决方案，适用于百万级指标的网络监控和应用监控。",
    },
    item5: {
      name: "阿里云",
      descript:
        "阿里云提供免费试用、云服务器、云数据库、云安全、云企业应用等云计算服务，以及大数据、人工智能服务、精准定制基于场景的行业解决方案。",
    },
    item6: {
      name: "腾讯企业邮箱",
      descript:
        "腾讯企业邮箱是为企业量身订造的一套办公用邮箱系统。我们为开发者提供了五大开放接口：通讯录管理、新邮件提醒、单点登录、系统日志、功能设置。",
    },
    item7: {
      name: "AWS 中国",
      descript:
        "亚马逊云科技，为全球客户提供整套基础设施和云解决方案。以弹性云服务器、云存储、数据库、机器学习为主的安全、可靠的云计算服务，帮助企业轻松上云。",
    },
    item8: {
      name: "ServiceDesk Plus",
      descript:
        "ServiceDesk Plus 将 IT 团队从日常救火转变为提供卓越的客户服务。它在处理 IT 问题时提供了良好的可见性和中央控制，以确保业务不会出现停机。",
    },
    item9: {
      name: "腾讯云",
      descript:
        "腾讯云为数百万的企业和开发者提供安全稳定的云计算服务，涵盖云服务器、云数据库、云存储、视频与 CDN、域名注册等全方位云服务和各行业解决方案。",
    },
    item10: {
      name: "ServiceDesk Plus 中国",
      descript:
        "ServiceDesk Plus 将 IT 团队从日常救火转变为提供卓越的客户服务。它在处理 IT 问题时提供了良好的可见性和中央控制，以确保业务不会出现停机。",
    },
  },
  createApp: {
    title: "没有找到需要的应用？",
    subtitle: "你可以到 Authing 论坛提交你所需要的应用信息",
    button: "提交申请",
  },
  apnDoc: {
    title: "想要加入 Authing 合作网络？",
    subtitle: "你可以将应用加入到 Authing 合作网络，让千万客户快速集成访问",
    button: "了解详情",
  },
  detailApp: {
    "btn-goback": "返回",
    "btn-getapp": "获取应用",
    "label-category": "分类",
    "label-developer": "开发者",
    "label-developer-company": "蒸汽记忆科技有限公司",
    "label-ability": "能力",
    "label-protocol": "协议",
    "title-intro": "简介",
    "title-link": "链接地址",
    "title-overview": "预览",
    "label-info": "信息",
    subtitle: "单点登录集成",
    forward: "敬请期待",
    esign: {
      title: "e签宝",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "e签宝是中国互联网电子签名行业领跑者。致力于为客户提供具有法律效力的电子合同全生命周期服务，将原本需要耗费数日之久的文件签署环节，压缩到只需几十秒。",
    },
    zoom: {
      title: "Zoom",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "Zoom 是现代企业视频通讯领域的领导者，为跨移动设备、台式机和会议室系统的视频/音频会议、协作、聊天和网络研讨会提供简单可靠的平台。Zoom Rooms 是基于软件的原创会议室解决方案，广泛应用于世界各地的董事会、会议室、小型会议室和培训室以及行政办公室和教室中。Zoom 成立于 2011 年，为企业和组织营造了一种畅通无阻的沟通环境，有助于实现团队协作、提升工作效率。Zoom 是一家总部位于加利福尼亚州圣何塞的上市公司。",
    },
    google: {
      title: "Google Workspace",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "Google Workspace（原 G Suite）：企业协作工具，一整套采用了 Google 人工智能技术且安全可靠的云端协作及高效办公应用，包括 Gmail、文档、云端硬盘、日历、Meet 等。",
    },
    github: {
      title: "Github Enterprise",
      tag: "项目管理",
      subtitle: "单点登录集成",
      intro:
        "Github Enterprise 是针对 Enterprise Cloud 和 Enterprise Server 的统一产品，允许组织自行配置基于云端或者自建的 GitHub。通过 GitHub Connect，这些产品可以互相关联并提供混合选项，开发者可以无缝展开工作。",
    },
    jira: {
      title: "Jira",
      tag: "项目管理",
      subtitle: "单点登录集成",
      intro:
        "在 Jira 中可以计划、跟踪和管理你的敏捷软件开发项目。自定义你的工作流、进行协作以及发布出色的软件。",
    },
    confluence: {
      title: "Confluence",
      tag: "项目管理",
      subtitle: "单点登录集成",
      intro:
        "Confluence 是一个团队工作空间，可有效融合知识与协作。提供可靠文档、决策、项目协作和 Jira 的可靠集成。",
    },
    lark: {
      title: "飞书",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "飞书是真正的一站式企业沟通与协作平台，整合即时沟通、日历、视频会议、电话会议、云文档、云盘、工作台、考勤打卡等功能于一体，打造高效的办公方式，加速企业成长。",
    },
    gitlab: {
      title: "GitLab",
      tag: "项目管理",
      subtitle: "单点登录集成",
      intro:
        "快速迭代，共同创新:我们的开放 DevOps 平台是一个具有无与伦比的协作、可见性和开发速度的单一应用程序。",
    },
    zabbix: {
      title: "Zabbix",
      tag: "项目管理",
      subtitle: "单点登录集成",
      intro:
        "Zabbix 是一个成熟、易用的企业级开源监控解决方案，适用于百万级指标的网络监控和应用监控。",
    },
    huaweicloud: {
      title: "华为云",
      tag: "云计算",
      subtitle: "单点登录集成",
      intro:
        "华为云为用户提供云服务器、云数据库、云存储、CDN、大数据、云安全等公有云产品和电商、金融、游戏等多种解决方案，7x24 小时客服支持，帮助企业轻松上云 - 华为云。",
    },
    alicloud: {
      title: "阿里云",
      tag: "云计算",
      subtitle: "单点登录集成",
      intro:
        "阿里云——阿里巴巴集团旗下公司，是全球领先的云计算及人工智能科技公司。提供免费试用、云服务器、云数据库、云安全、云企业应用等云计算服务，以及大数据、人工智能服务、精准定制基于场景的行业解决方案。免费备案，7x24 小时售后支持，助企业无忧上云。",
    },
    exmail: {
      title: "腾讯企业邮箱",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "腾讯企业邮箱是腾讯基于多年海量用户邮件系统研发和运营经验，为企业量身订造的一套办公用邮箱系统。我们为开发者提供了五大开放接口：通讯录管理、新邮件提醒、单点登录、系统日志、功能设置。希望帮助企业提升开发效率、降低开发成本和难度，从而提升生产和管理之间的协作效率。",
    },
    aws: {
      title: "AWS 中国",
      tag: "云计算",
      subtitle: "单点登录集成",
      intro:
        "亚马逊云科技——亚马逊公司旗下云计算服务平台，为全球客户提供整套基础设施和云解决方案。以弹性云服务器、云存储、数据库、机器学习为主的安全、可靠的云计算服务，帮助企业轻松上云。",
    },
    "service-desk-plus": {
      title: "ServiceDesk Plus",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "ServiceDesk Plus 是一个革命性产品，它将 IT 团队从日常救火转变为提供卓越的客户服务。它在处理 IT 问题时提供了良好的可见性和中央控制，以确保业务不会出现停机。经过 10 年的运行，它已经向数以百万计的 IT 人员、最终用户和涉众提供了良好的服务。",
    },
    "tencent-cloud": {
      title: "腾讯云",
      tag: "云计算",
      subtitle: "单点登录集成",
      intro:
        "腾讯云为数百万的企业和开发者提供安全稳定的云计算服务，涵盖云服务器、云数据库、云存储、视频与 CDN、域名注册等全方位云服务和各行业解决方案。",
    },
    "service-desk-plus-cn": {
      title: "ServiceDesk Plus 中国",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "ServiceDesk Plus 是一个革命性产品，它将 IT 团队从日常救火转变为提供卓越的客户服务。它在处理 IT 问题时提供了良好的可见性和中央控制，以确保业务不会出现停机。经过 10 年的运行，它已经向数以百万计的 IT 人员、最终用户和涉众提供了良好的服务。",
    },
    hongyi: {
      title: "鸿翼",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "上海鸿翼软件技术股份有限公司（以下简称鸿翼），是国内领先的 ECM（企业内容管理）及智能大数据管理服务商,致力于企业内容管理，数据保护，知识管理、企业网盘、文档管理系统、档案管理与可视化，数字工作环境构建等前沿技术的研发和产业应用。",
    },
    gnway: {
      title: "金万维",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "金万维作为国内受信赖的企业信息化互联网平台，定位于携手各行业管理软件提供商为企业提供信息化服务，我们不生产管理软件，而是通过提供售前、售中、售后的互联网平台服务，来帮助管理软件提供商及其用户成功。",
    },
    udesk: {
      title: "Udesk",
      tag: "CRM",
      subtitle: "单点登录集成",
      intro:
        "沃丰科技（Udesk）是国内领先的智能客户体验解决方案提供商，依托人工智能、大数据、云计算技术,旗下产品 Udesk、GaussMind、ServiceGo、微丰、沃丰 CEM。为企业提供一套完善的在线客服系统、智能客服系统、客服机器人、呼叫中心、工单系统、大数据分析平台、智能知识库、CRM 全渠道客服中心解决方案。",
    },
    slack: {
      title: "Slack",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "Slack 是一个适用于业务沟通的消息发送应用程序，它将人们与他们需要的信息联系起来。Slack 将人员集中到统一的团队中，改变了组织的沟通方式。Slack 有助于你以一种更紧密、更灵活、更包容的联系方式工作。",
    },
    wordpress: {
      title: "WordPress",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "全球最热门的网站构建器。42% 的网页在 WordPress 上构建。 越来越多的博主、小型企业和《财富》500 强公司使用 WordPress，其数量超过了其他所有选项的总和。",
    },
    seafile: {
      title: "Seafile",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "Seafile 是一款开源的企业云盘，注重可靠性和性能。支持 Windows, Mac, Linux, iOS, Android 平台。支持文件同步或者直接挂载到本地访问。",
    },
    kibana: {
      title: "Kibana",
      tag: "云计算",
      subtitle: "单点登录集成",
      intro:
        "Kibana 是一个免费且开放的用户界面，能够让你对 Elasticsearch 数据进行可视化，并让你在 Elastic Stack 中进行导航。你可以进行各种操作，从跟踪查询负载，到理解请求如何流经你的整个应用，都能轻松完成。",
    },
    jenkins: {
      title: "Jenkins",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "构建伟大，无所不能。Jenkins 是开源 CI&CD 软件领导者， 提供超过 1000 个插件来支持构建、部署、自动化， 满足任何项目的需要。",
    },
    teambition: {
      title: "Teambition",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "包括项目空间、网盘、文档、待办、日历 等新一代工具，帮助你把想法变成现实，让创作过程充满愉悦。由阿里巴巴 Teambition 团队打造，个人使用完全免费。",
    },
    salesforce: {
      title: "Salesforce",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "Salesforce 是一款可将公司和客户联系在一起的客户关系管理解决方案。Salesforce 是一个集成 CRM 平台，可以为你的所有部门（包括营销部门、销售部门、商务部门和服务部门）提供所有客户的单一共享视图。",
    },
    jfrog: {
      title: "JFrog",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "JFrog Artifactory 是目前全球唯一一个支持所有开发语言，任意维度的元数据检索、跨语言正反向依赖分析，并同时拥有深度递归、支持多活异地灾备的企业级、高可用二进制制品管理仓库。世界五百强中 93% 的企业已经将 Artifactory 作为自己 DevOps 的核心系统。",
    },
    zendesk: {
      title: "ZenDesk",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "Zendesk 形成了一套非常成熟的产品理念和产品体系，正如 Zendesk 自己介绍的一样，他们始终以客户服务为核心，提供完善的解决方案、强大而简洁的工具、拥有开放灵活的平台、积累了海量的数据、还有合理的定价模式，降低了企业的部署成本。",
    },
    fxiaoke: {
      title: "纷享销客",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "纷享销客连接型 CRM 系统-打造营销获客、销售管理、渠道管理、服务管理等一体化智能 CRM 平台， 自有 PaaS 平台满足中大型企业个性化需求，提供快消、农牧、制造业、高科技等行业专属 CRM 解决方案。",
    },
    adobe: {
      title: "Adobe",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "Adobe 正通过数字体验改变世界。我们帮助客户创建、传递和优化内容及应用程序。",
    },
    expensify: {
      title: "Expensify",
      tag: "办公",
      tag2: "财务",
      subtitle: "单点登录集成",
      intro:
        "Expensify 帮助用户追踪支出、提交费用报告、支付账单、生成发票、收取付款、跟踪里程、计划旅行，还可以帮用户获得最好的商务信用卡。",
    },
    qingflow: {
      title: "轻流",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "轻流-轻量级、可自定义的管理系统搭建平台，无需代码开发即可如搭积木般快速、​灵活地创造属于你的个性化管理系统，轻松实现多元业务场景的数字化管理。",
    },
    strapi: {
      title: "Strapi",
      tag: "云计算",
      subtitle: "单点登录集成",
      intro:
        "Strapi 是一个开源的 JavaScript 无外设内容管理系统，帮助用户在各类设备创建并管理内容。",
    },
    "aliyun-intel-user-sso": {
      title: "阿里云国际区",
      tag: "云计算",
      subtitle: "单点登录集成",
      intro:
        "阿里云——阿里巴巴集团旗下公司，是全球领先的云计算及人工智能科技公司。提供免费试用、云服务器、云数据库、云安全、云企业应用等云计算服务，以及大数据、人工智能服务、精准定制基于场景的行业解决方案。免费备案，7x24 小时售后支持，助企业无忧上云。",
    },
    "aws-en": {
      title: "AWS 国际区",
      tag: "云计算",
      subtitle: "单点登录集成",
      intro:
        "亚马逊云科技--亚马逊公司旗下云计算服务平台，为全球客户提供整套基础设施和云解决方案。以弹性云服务器、云存储、数据库、机器学习为主的安全、可靠的云计算服务，帮助企业轻松上云。",
    },
    maycur: {
      title: "每刻报销",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "每刻报销是每刻科技旗下智能费用管理云平台，是国内领先的企业差旅及费用管理SaaS平台，为企业提供差旅预定、费用报销管理、全流程费用管控服务。",
    },
    discourse: {
      title: "Discourse",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "Discourse 是一个简洁、平面化的论，回复就像瀑布一样线性显示在页面中。 回复可以展开，它们位于帖子的底部或顶部，以便你了解对话的完整上下文——而不用打断你的阅读。",
    },
    beisen: {
      title: "北森",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "北森一体化人才管理云平台，为企业提供覆盖人才测评、招聘管理、绩效管理、组织人事、薪酬、假勤、继任、调查、Onboarding 等业务全流程的一体化 HR SaaS 软件和服务，并通过自有 PaaS 平台满足中大型企业个性化和自主开发的需求。",
    },
    xiaoshouyi: {
      title: "销售易",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "销售易 CRM 是融合新型互联网技术的企业级 CRM 开创者，支持您的企业从营销、销售到服务的全流程自动化业务场景。除内部业务流程自动化外，还创新性地利用社交、移动、AI 和物联网技术支持您的企业连接外部的经销商、服务商、产品以及最终客户，赋能您的企业真正转型为以客户为中心的数字化运营组织，连接客户，服务客户，实现产业互联时代下的业绩规模化增长。",
    },
    metabase: {
      title: "Metabase",
      tag: "项目管理",
      subtitle: "单点登录集成",
      intro:
        "Metabase 是在公司内部共享数据和分析的最快、最简单的方法。一个开源的商业智能服务器，你可以在 5 分钟内安装，连接到 MySQL，PostgreSQL，MongoDB 和更多！任何人都可以使用它来构建图表、仪表板和每晚的电子邮件报告。",
    },
    jamf: {
      title: "Jamf Pro",
      tag: "办公",
      subtitle: "单点登录集成",
      intro:
        "Jamf Pro 是适用于 Apple 平台的综合企业管理软件，可简化 Mac、iPad、iPhone 和 Apple TV 的 IT 管理。",
    },
    sentry: {
      title: "Sentry",
      tag: "办公",
      tag1: "项目管理",
      subtitle: "单点登录集成",
      intro:
        "Sentry 的应用程序监控平台可帮助每个开发人员诊断、修复和优化其代码的性能。",
    },
    sonarqube: {
      title: "Sonarqube",
      tag: "项目管理",
      subtitle: "单点登录集成",
      intro:
        "Sonarqube 可以通过数以千计的自动静态代码分析规则捕获应用程序中的 bug 和漏洞。",
    },
    bitbucket: {
      title: "Bitbucket",
      tag: "项目管理",
      subtitle: "单点登录集成",
      intro:
        "Bitbucket 不仅仅是 Git 代码管理。 Bitbucket 为团队提供了一个地方来规划项目、协作编写代码、测试和部署。 它是一种基于 Web 的版本控制存储库托管服务，适用于使用 Mercurial 或 Git 版本控制系统的源代码和开发项目。",
    },
  },
  other: {
    "input-tip": "请输入搜索关键字",
    "app-null": "很抱歉，暂无“啊”相关内容",
  },
};
